import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoToSketchConfig } from '@/data/landingConfig/landingPhotoToSketchConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoToSketch } from './schemaObject';

interface Props {}
const PhotoToSketch: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoToSketch} />
			<LandingTemplate
				data={landingPhotoToSketchConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default PhotoToSketch;
